import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import {toast} from "react-toastify"
import {GET_SUPPLIER, GET_SUPPLIER_CURRENCY_DROPDOWN, SAVE_SUPPLIER} from "../constant/CommonApiUrl"
import {API_SERVICE} from "../Services/CommonApi";
import {ConvertJson} from "../helper";

const ADD_SUPPLIER = 'supplier/addSupplierApi'
const UPDATE_SUPPLIER = 'supplier/updateSupplierApi'
const FETCH_SUPPLIER = 'supplier/fetchSupplierApi'
const DELETE_SUPPLIER = 'supplier/deleteSupplierApi'
const GET_SUPPLIER_ID='supplier/getSupplierbyId'
const GET_SUPPLIER_CURRENCY='supplier/getSupplierCurrencyDropdown'

// Handles both AddEditSupplier failure shapes: 400 ModelState (used to fall
// through to a generic axios message) and 200 + status:false.
const extractSupplierSaveError = (err) => {
    const data = err?.response?.data;
    if (data?.status === 400 && data?.errors) {
        const firstField = Object.keys(data.errors)[0];
        return data.errors[firstField]?.[0] || data.title || "Please check the form and try again.";
    }
    return err?.message || "Unable to save this supplier. Please try again.";
}

export const addSupplierApi =createAsyncThunk(ADD_SUPPLIER,
    async(args, thunkAPI)=>{
        try{
            let response = await API_SERVICE.post(SAVE_SUPPLIER, args['data'], "CREATE");
            const result = response.data.result;
            if(!result.status){
                return thunkAPI.rejectWithValue(result.message || "Unable to save this supplier. Please try again.")
            }
            response = result.data; // single object, not array-wrapped
            thunkAPI.dispatch(fetchSupplierApi())
            return response;
        }catch(err){
            return thunkAPI.rejectWithValue(extractSupplierSaveError(err))
        }
})

export const updateSupplierApi = createAsyncThunk(UPDATE_SUPPLIER,
    async(args, thunkAPI)=>{
        try{
            let response = await API_SERVICE.post(SAVE_SUPPLIER, args['data'], "UPDATE");
            const result = response.data.result;
            if(!result.status){
                return thunkAPI.rejectWithValue(result.message || "Unable to save this supplier. Please try again.")
            }
            response = result.data; // single object, not array-wrapped
            thunkAPI.dispatch(fetchSupplierApi())
            return response;
        }catch(err){
            return thunkAPI.rejectWithValue(extractSupplierSaveError(err))
        }
})

export const deleteSupplierApi = createAsyncThunk(DELETE_SUPPLIER,
    async (args, thunkAPI) => {
        try{
            let toDelete = thunkAPI.getState().root.supplier.list.find(ele => ele.id === args['id']);
            // GetSupplier only has the derived code; refetch the real assigned
            // set so this soft-delete doesn't wipe it via currency_id.
            const assigned = await API_SERVICE.get(`${GET_SUPPLIER_CURRENCY_DROPDOWN}?supplier_id=${toDelete.id}`);
            const currency_id = (assigned.data?.result?.data || []).map(c => ({
                id: c.ID ?? c.id,
                is_primary: !!c.is_primary,
            }));
            const response = await API_SERVICE.post(SAVE_SUPPLIER, {...toDelete,port_id:ConvertJson(toDelete.port_id),isdisabled: "Y",currency_id});
            thunkAPI.dispatch(fetchSupplierApi())
            return response.data.result.data;
        }catch(err){
            return thunkAPI.rejectWithValue(extractSupplierSaveError(err))
        }
    }
)

// A supplier's assigned currencies. Task-wrapped envelope, unlike
// AddEditSupplier -- payload is at result.data.
export const getSupplierCurrencyDropdown = createAsyncThunk(GET_SUPPLIER_CURRENCY,
    async(supplierId, thunkAPI)=>{
        try{
            const response = await API_SERVICE.get(`${GET_SUPPLIER_CURRENCY_DROPDOWN}?supplier_id=${supplierId}`);
            return response.data?.result?.data || [];
        }catch(err){
            return thunkAPI.rejectWithValue(err.message)
        }
    }
)

export const fetchSupplierApi = createAsyncThunk(FETCH_SUPPLIER,
    async(arg,thunkAPI)=>{
        try{
            let response = await API_SERVICE.get(GET_SUPPLIER);
            response = response.data.result.data;
            return response
        }catch(err){
            return thunkAPI.rejectWithValue(err.message)
        }
    }
)
export const getSupplierbyId = createAsyncThunk(GET_SUPPLIER_ID,
    async(arg,thunkAPI)=>{
        try{
            return await API_SERVICE.get(`${GET_SUPPLIER}?ID=${arg}`)
        }catch(err){
            return thunkAPI.rejectWithValue(err.message)
        }
    }
)

const initialState={
    list:[],
    editSupplier:{},
    supplier_detail:{},
    portid:[],
    isUpdated: true    
}
export const SupplierSlice = createSlice({
    name:'supplier',
    initialState,
    reducers:{
        loadEditSupplier:(state,action)=>{
            console.log(action.payload)
            state.editSupplier={...action.payload, port_id:ConvertJson(action.payload.port_id)}
        },
        clearEditSupplier:(state,action)=>{
            state.editSupplier={}
        },         
        resetSupplier:()=>initialState
    },
    extraReducers:(builder)=>{
        builder
        .addCase(addSupplierApi.fulfilled,(state,action)=>{
            state.list=[...state.list,action.payload];
            toast.success('Succesfully added');
        })
        .addCase(updateSupplierApi.fulfilled,(state,action)=>{
            state.list = state.list.map(x => x.id === action.payload.id ? action.payload: x);
            toast.success('Succesfully updated');
        })
        .addCase(fetchSupplierApi.fulfilled, (state, action) => {
            state.list = action.payload;
            state.isUpdated = false;
        })
        .addCase(getSupplierbyId.fulfilled, (state, action) => {
            if(action.payload.data.result.status){
                let obj=action.payload.data.result.data[0]                             
                state.supplier_detail={...obj,portid:ConvertJson(obj.portid)}
                state.portid=ConvertJson(obj.portid)
            }else toast.error(action.payload.data.result.message)
        })
        .addCase(deleteSupplierApi.fulfilled, (state, action) => {
            state.list=state.list.filter(x=>x.id!==action.payload.id);
            toast.success('Succesfully deleted');
        })
    }   
})
export const {loadEditSupplier, clearEditSupplier, resetSupplier} = SupplierSlice.actions
export default SupplierSlice.reducer